import { Inject, Injectable } from "@angular/core";
import { ResourceService, SOFTLINE_SERVICE_HTTP } from "@softline/core";
import { Observable } from "rxjs";
import {
  SOFTLINE_API_LAGERKORREKTUR_ARTIKEL,
  SOFTLINE_API_SCAN_LAGERPLATZ
} from "../lagerkorrektur-artikel.api";
import { Artikel, LagerplatzInhalt } from "@softapps/lager/core";

@Injectable()
export class LagerkorrekturArtikelService {
  constructor(@Inject(SOFTLINE_SERVICE_HTTP) private service: ResourceService<any>) {
  }

  getQuelllagerplatz(code: string): Observable<LagerplatzInhalt> {
    const location = {
      path: SOFTLINE_API_SCAN_LAGERPLATZ,
      pathParams: {code}
    }
    return this.service.get(location);
  }

  lagerkorrektur(lagerplatzInhalt: LagerplatzInhalt, umbuchungsArtikel: Artikel) {
    const location = { path: SOFTLINE_API_LAGERKORREKTUR_ARTIKEL }
    return this.service.create(location, {
      lagerplatzInhalt,
      umbuchungsArtikel
    });
  }
}
